var VIEWS = {
    props: {
        loaded: Boolean,
        timelineConfigurations: Object,
        profileContent: Object
    },
    data: {
        projectViewType: {
            view: "",
            show: false
        },
        projectList: [],
        platform: { mobile: false }
    },
    emits: [
        "start-loader",
        "stop-loader",
        "timeline-configurations",
        "sub-navigation-navigate"
    ]
};

var TIMELINE = (CONFIG) => {
    return {
        timeline: {
            years: [],
            distance: 0,
            depth: 0,
            navigation: {
                showLeftControl: false,
                showRightControl: true
            },
            order: CONFIG.timeline.order,
            zoom: CONFIG.timeline.zoom,
            totalYears: 0,
            configurations: {
                enabled: false,
                attached: false,
                showZoomControl: false
            },
            priority: {
                selected: false,
                counts: {}
            },
            timelineData: [],
            selectedProject: {
                id: -1,
                timelineMapID: -1
            },
            searching: false,
            distinctProjectTypes: [],
            projectTypes: []
        }
    };
};

var PROJECT = { emits: [ "content-initiated" ] };

var SETTINGS = {
    data: { projectViewType: "" }
};

var SEARCH = {
    data: {
        search: {
            types: [],
            changeMade: false,
            current: {}
        }
    }
};

module.exports = {
    viewModel: VIEWS,
    timelineModel: TIMELINE,
    projectModel: PROJECT,
    settingsModel: SETTINGS,
    searchModel: SEARCH
};